<template>
	<page>
		<module enable-flex>
			<view-list ref="view" class="flex-grow" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadSummary">
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="关联订单号">
							<c-input name="order_no"></c-input>
						</m-search-item>
						<m-search-item label="销售渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="退款渠道">
							<c-select name="pay_channel" :options="payChannelOptions"></c-select>
						</m-search-item>
						<m-search-item label="售后类型">
							<c-select name="after_sale_type" :options="SALE_AFTER_SALE_TYPE"></c-select>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="after_sale_state" :options="SALE_AFTER_SALE_STATE"></c-select>
						</m-search-item>
						<m-search-item label="申请时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="退款时间" colspan="2">
							<c-datetime range start-name="refund_start_date" end-name="refund_end_date"></c-datetime>
						</m-search-item>
					</m-search>

					<!-- 售后账单汇总统计 -->
					<div class="stats-bar flex">
						<div class="stats-card card-blue">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">退货台数</span>
									<span class="stats-value">{{ formatNumber(summary.total_count) }}</span>
								</div>
							</div>
							<div class="stats-icon"><i class="tf tf-phone"></i></div>
						</div>
						<div class="stats-card card-orange">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">总成本</span>
									<span class="stats-value">￥{{ formatMoney(summary.total_cost) }}</span>
								</div>
							</div>
							<div class="stats-icon">¥</div>
						</div>
						<div class="stats-card card-red">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">售后总金额</span>
                                    <span class="stats-value">￥{{ formatMoney(summary.total_amount) }}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>补差金额：</label>￥{{ formatMoney(summary.total_refund_amount) }}</span>
                                    <ins>|</ins>
                                    <span><label>退机金额：</label>￥{{ formatMoney(summary.total_return_amount) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
						</div>
					</div>
				</template>

				<template #operate>
					<c-button v-if="auth('b_after_sale_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!-- 产品信息 -->
				<template #product_info="{data}">
					<m-product-info :name="data.product_name || getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>

				<!-- 背贴码 -->
				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<!-- IMEI -->
				<template #imei="{data}">
					{{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<!-- 成本价 -->
				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<!-- 销售价 -->
				<template #sale_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<!-- 退款金额 -->
				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<!-- 退款渠道（原路退回的支付渠道） -->
				<template #pay_channel="{data}">
					{{getPayChannelName(data)}}
				</template>

				<!-- 售后类型 -->
				<template #after_sale_type="{data}">
					<c-state async tag dict="SALE_AFTER_SALE_TYPE" :value="data.after_sale_type"></c-state>
				</template>

				<!-- 关联订单号 -->
				<template #order_no="{data}">
					{{data.order_no || '-'}}
				</template>

				<!-- 销售渠道 -->
				<template #channel_name="{data}">
					{{data.channel_name || '-'}}
				</template>

				<!-- 申请时间 -->
				<template #create_date="{data}">
					{{data.create_date || ''}}
				</template>

				<!-- 结算时间 -->
				<template #settle_date="{data}">
					{{data.settle_date || ''}}
				</template>

				<!-- 结算金额（订单结算金额，同一订单多条售后明细时重复） -->
				<template #settled_amount="{data}">
					{{formatPrice(data.settled_amount)}}
				</template>

				<!-- 退款时间 -->
				<template #refund_date="{data}">
					{{data.refund_date || ''}}
				</template>

				<!-- 状态 -->
				<template #after_sale_state="{data}">
					<c-state async tag dict="SALE_AFTER_SALE_STATE" :value="data.after_sale_state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
	name: 'm_after_sale_bill',

	data() {
		return {
			workType: 117,
			summary: {},
			//退款渠道（原路退回的支付渠道）选项
			payChannelOptions: [{
                name: '通联支付',
                value: 'balance'
            },{
				name: '微信支付',
				value: 'wxpay'
			}, {
				name: '微信扫码',
				value: 'wxpay_scan'
			}, {
				name: '支付宝',
				value: 'alipay'
			}, {
				name: '支付宝扫码',
				value: 'alipay_scan'
			}, {
				name: '现金',
				value: 'offline_cash'
			}, {
				name: '收款码',
				value: 'offline_qr_code'
			}, {
				name: '银行转账',
				value: 'offline_bank_card'
			}, {
				name: '授信支付',
				value: 'credit'
			}]
		}
	},

	computed: {
		...mapState(['saasInfo']),

		...asyncMapState(['SALE_AFTER_SALE_STATE', 'SALE_AFTER_SALE_TYPE'])
	},

	methods: {
		/*********搜索销售渠道**********/
		searchChannel(keyword, resolve) {
			this.request({
				url: '/sale/product/channel/options',
				data: {
					keyword: keyword
				},
				success: data => {
					resolve((data || []).map(item => {
						return {
							name: item.channel_name,
							value: item.channel_id
						};
					}));
				}
			});
		},

		/*********加载汇总统计（随列表查询条件联动）**********/
		loadSummary(listData, searchParams) {
			this.request({
				url: '/financial/aftersale/bill/summary',
				data: searchParams || {},
				success: data => {
					this.summary = data || {};
				}
			});
		},

		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********退款渠道名称（无支付单渠道时，线下售后按线下支付展示）**********/
		getPayChannelName(data) {
			if (data.pay_channel) {
				var channel = this.payChannelOptions.find(item => item.value == data.pay_channel);
				return channel ? channel.name : data.pay_channel;
			}
			return data.order_type == 1 ? '线下支付' : '-';
		},

		/*********格式化价格**********/
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '¥' + parseFloat(price).toFixed(2);
		},

		/**
		 * 金额格式化（保留两位小数）
		 */
		formatMoney(val) {
			if (val === undefined || val === null || val === '') {
				return '0.00';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0.00' : num.toFixed(2);
		},

		/**
		 * 数量格式化
		 */
		formatNumber(val) {
			if (val === undefined || val === null || val === '') {
				return '0';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0' : String(Math.round(num));
		}
	}
}
</script>

<style lang="stylus" scoped>
.stats-bar {
    flex-shrink: 0;
    gap: 10px;
	border-top: 1px solid #F5F5F5;
	padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        max-width: 360px;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.card-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.card-red {
            background: linear-gradient(90deg, #dc2626, #ef4444);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .stats-summary-row {
                gap: .5em;
                margin-top: 2px;
                font-size: 11px;

                ins {
                    text-decoration: none;
                    opacity: 0.6;
                }

                label {
                    opacity: 0.9;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;

            .tf {
                font-size: 32px;
            }
        }
    }
}
</style>
